import { useCallback, useEffect } from 'react'

/*
 * Trigger callback when clicking outside the ref element
 * */
const useClickOutside = (ref: any, callback: () => any) => {
    const handleClick = useCallback(() => {
        // $FlowFixMe
        if (ref.current && !ref.current.contains(event.target)) {
            callback()
        }
    }, [ref, callback])

    useEffect(() => {
        document.addEventListener('mousedown', handleClick)

        return () => {
            document.removeEventListener('mousedown', handleClick)
        }
    }, [handleClick])
}

export default useClickOutside
